export const DOCUMENT_SOURCE_SECRET_THRESHOLD_DAYS = 90;
export const DOCUMENT_SOURCE_EMAIL_DOMAIN = "ToTilley.com";
